import * as moment_timezone from "moment-timezone";

// date : une date
// rawDate :
//     Si true, on indique que la date ne contient pas l'indicateur de timezone (ex : 2022-01-01)
//     Si false, on indique que la date contient l'indicateur de timezone (ex : 2022-01-01T00:00:00+01:00)
export function moment(date, rawDate = false) {
    const m = moment_timezone(date);

    // Si l'offset depuis UTC est différent le même entre la date donnée et le moment présent
    // Renvoie false si la date et maintenant ne sont pas dans la même prédiode de changement d'heure
    // ex : Aujourd'hui : 01/06 -> heure d'été -> UTC +2
    //      Date passée : 01/12 -> heure d'hiver -> UTC +1
    // if (m.utcOffset() === moment_timezone().utcOffset()) {
    let formattedDate = moment_timezone(date).tz("Europe/Paris", false);

    if (rawDate) {
        formattedDate = formattedDate.add(
            moment_timezone(date).utcOffset() +
                moment_timezone()
                    .tz("Europe/Paris", false)
                    .utcOffset(),
            "minutes"
        );
    }

    return formattedDate;

    // Solution de base
    // .add(
    //     moment_timezone(date).utcOffset() * -1 +
    //         moment_timezone()
    //             .tz("Europe/Paris", false)
    //             .utcOffset(),
    //     "minutes"
    // )

    // Solution alternative
    // .add(
    //     Math.abs(moment_timezone(date).utcOffset()) -
    //         moment_timezone()
    //             .tz("Europe/Paris", false)
    //             .utcOffset(),
    //     "minutes"
    // )
    // } else {
    //     return moment_timezone(date);
    // }
}



// WEBPACK FOOTER //
// ./src/utils/moment.js